import { OBaseModel } from '@olameter/o-utilities';
import { UserFile } from 'src/app/proto/generated/User_message_pb';

export class UserFileModel implements OBaseModel {
  name: string;
  fileName: string;
  fileUrl: string;

  static Mapper(file: UserFile): UserFileModel {
    if (file) {
      return {
        name: file.getName(),
        fileName: file.getFileName(),
        fileUrl: file.getFileUrl(),
      };
    }
    return undefined;
  }
}
